import { useDnaTracker } from "@/features/holifya-tests/dna-test/hooks/useDnaTracker";
import { DnaTestTrackingStatus } from "@/features/holifya-tests/dna-test/types/DnaTestTrackingStatus";
import { useNavigate } from "react-router-dom";

export const useDnaTestWidget = () => {
    const { dnaTracker, dnaOrderId, updateTracker } = useDnaTracker()
    const navigate = useNavigate()

    type DnaWidgetConfig = {
        text: string;
        buttonText: string;
        onClick: () => void;
        variant?: "default" | "success"; // You can expand this if needed
    };

    const configMap: Partial<Record<DnaTestTrackingStatus, DnaWidgetConfig>> = {
        [DnaTestTrackingStatus.Purchased]: {
            text: "📦 Hai ricevuto il kit?",
            buttonText: "Sì, ricevuto",
            onClick: () => updateTracker(DnaTestTrackingStatus.Delivered, dnaOrderId!),
        },
        [DnaTestTrackingStatus.Delivered]: {
            text: "🧬 Effettua il test del DNA",
            buttonText: "Effettua",
            onClick: () => navigate("/dna-test/tutorial"),
        },
        [DnaTestTrackingStatus.TestDone]: {
            text: "🔐 Registra il Codice campione",
            buttonText: "Registra",
            onClick: () => navigate("/dna-test/register-swab-code"),
        },
        [DnaTestTrackingStatus.SampleRegistered]: {
            text: "🚛 Richiedi il ritiro del campione",
            buttonText: "Richiedi",
            onClick: () => navigate("/dna-test/packing"),
        },
        [DnaTestTrackingStatus.PickupRequested]: {
            text: "🚛 Modifica il ritiro del campione",
            buttonText: "Modifica",
            onClick: () => navigate("/dna-test/request-pickup"),
        },
        [DnaTestTrackingStatus.Departed]: {
            text: "🚛 Verso il laboratorio",
            buttonText: "",
            onClick: () => { },
        },
        [DnaTestTrackingStatus.DeliveredToLaboratory]: {
            text: "📍 Arrivato in laboratorio",
            buttonText: "",
            onClick: () => { },
        },
        [DnaTestTrackingStatus.StartingToExtract]: {
            text: "🧪 Inizio estrazione",
            buttonText: "",
            onClick: () => { },
        },
        [DnaTestTrackingStatus.StartingAnalysis]: {
            text: "🔬 In analisi",
            buttonText: "",
            onClick: () => { },
        },
        [DnaTestTrackingStatus.AnalysisDone]: {
            text: "🧬 Risultati in arrivo",
            buttonText: "",
            onClick: () => { },
        },
        [DnaTestTrackingStatus.ReportGenerated]: {
            text: "🧬 Visualizza risultati",
            buttonText: "Visualizza",
            onClick: () => navigate("/dna-test"),
            variant: "success",
        },
    };

    const defaultReturn = {
        text: "Start your DNA test today.",
        buttonText: "Get Started",
        onClick: () => { },
        variant: "default",
    };

    const config = configMap[dnaTracker as DnaTestTrackingStatus];

    return {
        ...config ?? defaultReturn,
        variant: config?.variant ?? "default",
    };
}